var path = '/components/views/select-or-create-rsvp-modal.tpl.html';
var html = "<button class=\"close\" ng-click=\"vm.close()\"><i class=\"fal fa-times\"></i></button>\n<div class=\"modal-header\">\n    <h2>Select or Create a new Booking</h2>\n</div>\n<div class=\"modal-body\">\n    <p>You can either select an existing booking or make a new booking from an existing contact or a new contact</p>\n    <div class=\"btn-group\">\n        <button ng-click=\"vm.selectRsvp()\">Existing Booking</button>\n        <button ng-click=\"vm.makeBooking()\">Existing Contact</button>\n        <button ng-click=\"vm.addContact()\">New Contact</button>\n    </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/select-or-create-rsvp-modal.tpl.html
// module id = 2049
// module chunks = 1